import { dispatch } from 'nike-re-framejs';
import axios from 'axios';
import { getUrl } from '@/common/oldMobile';
import DmsService from '@/uploadDocument/services/DmsService';

export const saveAccountCancerRequestConfig = data => db => db.update(DmsService.processConfigDataUpdater(data));

export const getAccountCancelRequestDocConfig = db => {
    const path = ['documentsUpload', 'config'];

    if (!db.getIn(path)) {
        axios.get(getUrl('ACCOUNT_CANCEL_INIT')).then(data => dispatch(saveAccountCancerRequestConfig(data)));
    }

    return db;
};

export const cleanupDocUploads = db => {
    return db.deleteIn(['documentsUpload']);
};
